export const clearLayers = (layers) => {
    layers.shapes.destroyChildren();
    layers.image.batchDraw();
    layers.shapes.batchDraw();
};
